import { Link } from 'gatsby';
import React from 'react';
import styled from 'styled-components';

import Commerce7 from '../../icons/commerce7-logomark.svg';

import FooterLink from './FooterLink';

const Links = () => (
  <Wrapper>
    <Container>
      <Logo>
        <Link to="/" title="View Home Page.">
          <Commerce7 />
        </Link>
      </Logo>
      <LinkGroup>
        <LinkGroupLabel>Solutions</LinkGroupLabel>
        <FooterLink to="/solutions/pos" label="Point of Sale" />
        <FooterLink to="/solutions/club" label="Clubs &amp; Subscriptions" />
        <FooterLink to="/solutions/ecommerce" label="Ecommerce" />
        <FooterLink to="/solutions/crm" label="CRM" />
        <FooterLink to="/solutions/reservations" label="Reservations" />
        <FooterLink to="/solutions/payments" label="Payments" />
      </LinkGroup>
      <LinkGroup>
        <LinkGroupLabel>Customers</LinkGroupLabel>
        <FooterLink
          to="/customers/united-states/pacific-northwest"
          label="United States"
        />
        <FooterLink to="/customers/canada/niagara" label="Canada" />
        <FooterLink
          to="/customers/australia-and-new-zealand/australia"
          label="Australia / New Zealand"
        />
        <FooterLink to="/customers/south-africa" label="South Africa" />
        <FooterLink to="/customers/europe" label="Europe" />
        <FooterLink to="/customers/small" label="Small" />
        <FooterLink to="/customers/midsize" label="Midsize" />
        <FooterLink to="/customers/enterprise" label="Enterprise" />
      </LinkGroup>
      <LinkGroup>
        <LinkGroupLabel>Partners</LinkGroupLabel>
        <FooterLink to="/partners/apps" label="App Store" />
        <FooterLink to="/partners/designers" label="Find a Design Partner" />
        <FooterLink to="/partners/become-a-partner" label="Become a Partner" />
        <FooterLink
          href="https://design-docs.commerce7.com/docs"
          label="Designer Docs"
        />
        <FooterLink
          href="https://developer.commerce7.com/docs"
          label="Developer Docs"
        />
      </LinkGroup>
      <LinkGroup>
        <LinkGroupLabel>Resources</LinkGroupLabel>
        <FooterLink to="/blog" label="Blog" />
        <FooterLink to="/article" label="Articles" />
        <FooterLink
          href="https://documentation.commerce7.com"
          label="Documentation"
        />
        <FooterLink
          href="https://commerce7academy.commerce7.com/"
          label="Commerce7 Academy"
        />
        <FooterLink
          href="https://vimeo.com/showcase/c7videohub"
          label="Video Hub"
        />
      </LinkGroup>
      <LinkGroup>
        <LinkGroupLabel>Company</LinkGroupLabel>
        <FooterLink to="/about" label="About" />
        <FooterLink to="/careers" label="Careers" />
        <FooterLink to="/press" label="Press" />
        <FooterLink to="/privacy" label="Privacy Policy" />
        <FooterLink to="/terms" label="Terms of Service" />
      </LinkGroup>
    </Container>
  </Wrapper>
);

const Wrapper = styled.div``;

const Container = styled.div`
  max-width: 1700px;
  margin: auto;
  padding: 40px 20px 40px 20px;
  display: flex;
  flex-wrap: wrap;
  align-items: start;
  justify-content: space-between;
  ${({ theme }) => `
  @media ${theme.mediumUp} {
    padding: 40px 50px 40px 50px;
  }
    @media ${theme.largeUp} {
      padding: 90px 54px 40px 54px;
    }
  `}
`;

const Logo = styled.div`
  width: 100%;
  margin-bottom: 40px;
  > a {
    display: inline-flex;
    align-items: center;
  }
  ${({ theme }) => `
    @media ${theme.largeUp} {
        width: ${100 / 6}%;
    }
  `}
`;

const LinkGroup = styled.div`
  width: 50%;
  margin-bottom: 40px;

  ${({ theme }) => `
    @media ${theme.mediumUp} {
        width: ${100 / 6}%;
    }
  `}
`;

const LinkGroupLabel = styled.strong`
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-lg);
  color: var(--blue-dark);
  display: block;
  margin-bottom: 21px;
`;

export default Links;
